@app.factory 'FlagsService', ($resource, csConfig) ->
  Flags = $resource "#{csConfig.chefstepsEndpoint}/api/v0/flags", { },
    'index':
      method: 'GET'

  Flags
